import React from 'react';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const UnlinkIcon = () => (
  <Icon tooltip="Unlink" iconObj={faTrashAlt} />
);

export default UnlinkIcon;